export default __webpack_public_path__ + "static/media/reciever-vector-tip.cbef1a33.svg";